import React from "react";
import { observer } from "mobx-react";
import { AuthorComposerViewStore } from "../../store";
import { AuthorComposerPublicViewForm } from "./AuthorComposerPublicViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type AuthorComposerPublicViewProps = {
  authorComposerViewStore: AuthorComposerViewStore;
};

export const AuthorComposerPublicView: React.FC<AuthorComposerPublicViewProps> =
  observer(({ authorComposerViewStore }) => {
    return (
      <div>
        <AuthorComposerPublicViewForm
          authorComposerViewStore={authorComposerViewStore}
          firstName={authorComposerViewStore.firstNameValue}
          lastName={authorComposerViewStore.lastNameValue}
          genderOptions={authorComposerViewStore.getGenderOptions()}
          gender={authorComposerViewStore.genderValue}
          taxIdTypeOptions={authorComposerViewStore.getTaxIdTypeOptions()}
          taxIdType={authorComposerViewStore.taxIdTypeValue}
          taxId={authorComposerViewStore.taxIdValue}
          email={authorComposerViewStore.emailValue}
          phone={authorComposerViewStore.phoneValue}
          nationalityValue={authorComposerViewStore.nationalityValue}
          dateOfBirth={authorComposerViewStore.dateOfBirthValue}
          streetAndNumber={authorComposerViewStore.streetAndNumberValue}
          floor={authorComposerViewStore.floorValue}
          suite={authorComposerViewStore.suiteValue}
          postalCode={authorComposerViewStore.postalCodeValue}
          countryValue={authorComposerViewStore.countryValue}
          provinceValue={authorComposerViewStore.provinceValue}
          city={authorComposerViewStore.cityValue}
          aka={authorComposerViewStore.akaValue}
          ipi={authorComposerViewStore.ipiValue}
          recordId={authorComposerViewStore.authorComposerInstance?.id || ""}
          onPrint={(handlePrint: () => void) =>
            authorComposerViewStore.printAuthorComposer(handlePrint)
          }
          onCancel={() => authorComposerViewStore.cancelAuthorComposer()}
          onEdit={
            authorComposerViewStore.isEditEnabled
              ? () => authorComposerViewStore.editAuthorComposer()
              : undefined
          }
        />
        <ErrorDialog
          open={authorComposerViewStore.errorDialogOpened}
          title={authorComposerViewStore.errorTitle}
          description={authorComposerViewStore.errorDescription}
          onClose={() => authorComposerViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
